import { api_gateway } from '../../conexoes/api'
import decryptJWT from '../../utils/decryptJWT'

export async function getListaParceiros(parceiro) {
  try {
    let parceiroObj = await api_gateway.get(
      '/m1/servicos/pre_login_cliente_parceiro?rota=' + parceiro
    )
    return parceiroObj.data
  } catch (e) {
    console.error('erro ao entrar na m1/servicos/prelogin', e)
    return []
  }
}

export async function tokenRecuperacaoOk(token, login) {
  const confirmacao = await api_gateway
    .post('/m1/servicos/dados/validar_usuario_recuperacao ', { token, login })
    .then(function () {
      return true
    })
    .catch(function () {
      return false
    })
  return confirmacao
}

export async function getInformacoesAdicionaisCustomizadasClientes() {
  return await api_gateway.get(
    '/m1/consultar/informacoes_adicionais_customizadas_cliente?cd_pav_cliente=' +
      decryptJWT('codigoCliente')
  )
}

export async function postUsuarioRecuperacao({
  tokenUrl,
  novaSenha,
  senhaAtual,
  emailUrl,
  primeiroAcesso
}) {
  const condicao = {
    ds_email: emailUrl
  }

  if (primeiroAcesso) {
    condicao.fl_padrao_senha = 1
  }

  const dados = {
    token: tokenUrl,
    ds_senha: novaSenha
  }

  if (senhaAtual) {
    dados.ds_senha_atual = senhaAtual
  }

  return await api_gateway.post('/m1/servicos/dados/usuario_recuperacao', {
    dados: dados,
    condicao: condicao
  })
}

export async function postServicosDadosLoginAlgar(user) {
  return await api_gateway.post('/m1/servicos/dados/login', {
    ds_email: user,
    ds_senha: '',
    algar: true
  })
}

export async function postServicosDadosLogin({
  email,
  password,
  token,
  method,
  userIP
}) {
  return await api_gateway.post('/m1/servicos/dados/login', {
    ds_email: email,
    ds_senha: password,
    ds_token: token,
    ds_method: method,
    ds_user_ip: userIP
  })
}

export async function alterarColunasSimcard({
  email,
  colunasAux,
  colunasFaturasAux
}) {
  return await api_gateway.post('m1/servicos/dados/alterar_colunas_simcard', {
    email: email,
    colunas: colunasAux,
    colunasFaturas: colunasFaturasAux
  })
}

export async function getEmailRecuperacao(emailRecuperarSenha) {
  return await api_gateway.get(
    'm1/servicos/token/email_recuperacao?ds_email=' + emailRecuperarSenha,
    {},
    { timeout: 20000 }
  )
}

export async function cadastrarColunasSimcard({
  email,
  colunasSimcard,
  colunasFaturas
}) {
  return await api_gateway.post(
    '/m1/servicos/dados/cadastrar_colunas_simcard',
    {
      email: email,
      colunas: colunasSimcard,
      colunasFaturas: colunasFaturas
    }
  )
}

export async function getColunasSimcard(email) {
  return await api_gateway.post('m1/servicos/dados/buscar_colunas_simcard', {
    email
  })
}

export async function getColunasFaturas(email) {
  return await api_gateway.post('m1/servicos/dados/buscar_colunas_faturas', {
    email: email
  })
}

export async function postAceitarTermos(email) {
  return await api_gateway.post('/m1/servicos/dados/aceitar_termos', {
    ds_email: email
  })
}

export async function postAlterarTermos() {
  return await api_gateway.post('m1/alterar/usuario/termo_contrato')
}
